import { render, staticRenderFns } from "./V_Ongoing_QuestRules.vue?vue&type=template&id=0a044030&scoped=true&"
import script from "./V_Ongoing_QuestRules.vue?vue&type=script&lang=js&"
export * from "./V_Ongoing_QuestRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a044030",
  null
  
)

export default component.exports